import React from 'react';

type UseESimModalStateReturnType = [boolean, () => void];

export const useESimModalState = (): UseESimModalStateReturnType => {
  const [state, setState] = React.useState<boolean>(false);

  const toggleESimOpenModal = React.useCallback<() => void>(() => {
    setState((prevState) => !prevState);
  }, []);

  return React.useMemo<UseESimModalStateReturnType>(() => [state, toggleESimOpenModal], [state]);
};
